export const CONTACT_INFO = ["Aneesh Roghaan - 9361683163 ", "Aishwarya R - 9003688747"]

export const TECHIES_INFO = [ "Kathir RM - 6385396678", "Velan - 9442783160"] 